module.exports = __webpack_public_path__ + "static/yashwantB-b41eb464eba2d1730a3ab7f439ce80e3.jpg";